export default __webpack_public_path__ + "static/prog21-umbrella-8ea4cd66c6eb032e18ffe96d8bba9516.svg";